import { heroTags, heroCover } from "@/mocks/home-data";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-10 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl" />

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-10 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-8">
        {/* 文案优先 */}
        <div className="fade-up flex flex-col justify-center lg:col-span-7">
          <div className="mb-6 flex items-center gap-3">
            <span className="font-label text-xs font-semibold uppercase tracking-[0.24em] text-primary-600">
              每日雷讯 · 杂志速读
            </span>
            <span className="h-px w-10 bg-primary-300" />
            <span className="font-label text-xs font-semibold text-foreground-600">第 038 期</span>
          </div>

          <h1 className="display-serif text-4xl font-black leading-[1.15] text-foreground-950 md:text-6xl">
            别一个个追了，
            <br />
            今晚把大瓜合集
            <br />
            <span className="text-primary-600">一次打包给你看够。</span>
          </h1>

          <p className="mt-6 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            雷点整理、吃瓜清单、事件脉络、劲爆盘点，全在这一页归拢。从一个瓜的起点、反转到收尾，
            来龙去脉摊得明明白白，刷完这一屏，跟人聊瓜就不会掉线。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#leidian"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              进瓜棚看盘点
              <i className="ri-arrow-right-line text-base" />
            </a>
            <a
              href="#changchang"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              去吃瓜现场
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line text-sm text-primary-600" /> 今天 22:18 更新
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-check-double-line text-sm text-accent-600" /> 已核实 86 处实锤
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-add-circle-line text-sm text-secondary-600" /> 今日新增 12 个瓜
            </span>
          </div>
        </div>

        {/* 视觉陪衬：竖版封面 */}
        <div className="lg:col-span-5">
          <div className="relative mx-auto max-w-sm lg:max-w-none">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <img
                src={heroCover}
                alt="大雷网站大瓜合集杂志封面"
                title="大雷网站大瓜合集杂志封面"
                className="h-[360px] w-full object-cover object-top md:h-[440px]"
              />
            </div>
            <div className="absolute -bottom-5 left-5 right-5 rounded-md border border-background-200 bg-background-50/95 p-4 backdrop-blur">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-600">
                    本期封面瓜
                  </p>
                  <p className="mt-1 font-heading text-sm font-bold text-foreground-950">
                    三周三雷，塌到彻底
                  </p>
                </div>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-fire-fill text-lg" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动热词条 */}
      <div className="relative border-t border-background-200 bg-background-100/70">
        <div className="mx-auto flex max-w-[1280px] items-center gap-4 px-4 py-2.5 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 font-label text-xs font-semibold text-foreground-800">
            <i className="ri-flashlight-fill text-primary-500" /> 正在热
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max gap-6">
              {[...heroTags, ...heroTags, ...heroTags].map((t, i) => (
                <a
                  key={i}
                  href="#baoliao"
                  className="font-label whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
                >
                  <span className="mr-1 text-primary-500">#</span>
                  {t}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}